import { FC, ReactNode, useEffect, useRef, useState } from 'react'

export interface AsyncRenderOnScrollProps {
  loadingComponent?: ReactNode
  fetchData: () => Promise<any>
  render: (data: any) => ReactNode
}

const AsyncRenderOnScroll: FC<AsyncRenderOnScrollProps> = ({
  loadingComponent,
  fetchData,
  render,
}) => {
  const [data, setData] = useState<any>(null)
  const [isVisible, setIsVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleData = async () => {
      setIsLoading(true)
      try {
        const data = await fetchData()
        setData(data)
      } catch (error) {
        // ignore error
      } finally {
        setIsLoading(false)
      }
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.unobserve(entry.target)
          handleData()
        }
      },
      { threshold: 0.5 }
    )

    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [fetchData])

  return (
    <div ref={ref}>
      {isVisible ? isLoading ? loadingComponent : render(data) : null}
    </div>
  )
}

export default AsyncRenderOnScroll
